import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { buildBreadcrumbSchema } from '../../lib/breadcrumbs';

// Injects a separate <script type="application/ld+json" id="page-breadcrumb">
// per route. Distinct id from the page-level structured-data block so the
// existing SEO component's structuredData prop continues to manage its own
// payload independently.

const SCRIPT_ID = 'page-breadcrumb';

const BreadcrumbSchema = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const existing = document.getElementById(SCRIPT_ID);
    const payload = buildBreadcrumbSchema(pathname);

    if (!payload) {
      if (existing) existing.remove();
      return undefined;
    }

    const json = JSON.stringify(payload);
    if (existing) {
      if (existing.text !== json) existing.text = json;
    } else {
      const el = document.createElement('script');
      el.type = 'application/ld+json';
      el.id = SCRIPT_ID;
      el.text = json;
      document.head.appendChild(el);
    }

    return () => {
      // Don't remove on unmount — the next route will replace or remove
      // the script as appropriate.
    };
  }, [pathname]);

  return null;
};

export default BreadcrumbSchema;
